import { render, staticRenderFns } from "./PDFFindControls.vue?vue&type=template&id=28212110&scoped=true"
import script from "./PDFFindControls.vue?vue&type=script&lang=ts"
export * from "./PDFFindControls.vue?vue&type=script&lang=ts"
import style0 from "./PDFFindControls.vue?vue&type=style&index=0&id=28212110&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28212110",
  null
  
)

export default component.exports